import './SuggestionPart.css';
export var suggestionPartSectionInfoCSS = '_yhio8f0-3-5-0';